import { useEffect, useState } from 'react';

/**
 * Fração da altura reservada a cabeçalho, rodapé, título do grupo e cabeçalho
 * da tabela. Acompanha os tamanhos em `vh` do telão.
 */
const RESERVED_FRACTION = 0.36;
/** Altura de uma linha (nome + escola) com as fontes do telão. */
const ROW_FRACTION = 0.068;

/** Quantas linhas da tabela cabem na coluna de classificação. */
export default function useRowsPerPage(): number {
  const compute = () => {
    const h = window.innerHeight;
    const rowPx = Math.max(48, h * ROW_FRACTION);
    return Math.max(5, Math.floor((h * (1 - RESERVED_FRACTION)) / rowPx));
  };

  const [rows, setRows] = useState(compute);

  useEffect(() => {
    const onResize = () => setRows(compute());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return rows;
}
